import React, { useState } from 'react';
import './App.css';

const WHATSAPP_LINK = 'https://wa.me/message/S6LHFSLWXB4CL1';

const Icon = ({ name, size = 20 }) => {
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
  };

  const paths = {
    arrow: <><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></>,
    check: <><path d="m5 12 4 4L19 6" /></>,
    clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
    box: <><path d="m12 3 9 5-9 5-9-5 9-5Z" /><path d="M3 8v9l9 5 9-5V8M12 13v9" /></>,
    truck: <><path d="M3 6h11v12H3zM14 10h4l3 3v5h-7z" /><circle cx="7.5" cy="18" r="1.5" /><circle cx="17.5" cy="18" r="1.5" /></>,
    shield: <><path d="M12 22s8-4 8-11V5l-8-3-8 3v6c0 7 8 11 8 11Z" /><path d="m9 12 2 2 4-4" /></>,
    location: <><path d="M20 10c0 5-8 12-8 12S4 15 4 10a8 8 0 1 1 16 0Z" /><circle cx="12" cy="10" r="2.5" /></>,
    phone: <><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.4 19.4 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7l.5 3a2 2 0 0 1-.6 1.8L7.7 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 1.8-.6l3 .5a2 2 0 0 1 2.2 2.5Z" /></>,
    menu: <><path d="M4 7h16M4 12h16M4 17h16" /></>,
    close: <><path d="m18 6-12 12M6 6l12 12" /></>,
    star: <><path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3 1.1-6.2L3 9.6l6.2-.9L12 3Z" /></>,
    quote: <><path d="M3 21c3 0 5-2 5-5V9H2v6h3c0 2-1 3-2 3v3ZM14 21c3 0 5-2 5-5V9h-6v6h3c0 2-1 3-2 3v3Z" /></>,
    instagram: <><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><path d="M17.5 6.5h.01" /></>,
    facebook: <><path d="M14 8h3V4h-3a5 5 0 0 0-5 5v3H6v4h3v4h4v-4h3l1-4h-4V9a1 1 0 0 1 1-1Z" /></>,
    whatsapp: <><path d="M20.5 11.5a8.5 8.5 0 0 1-12.6 7.4L3 20l1.2-4.6a8.5 8.5 0 1 1 16.3-3.9Z" /><path d="M8 8.2c.3-.5.6-.5 1-.5h.4c.2 0 .4.1.5.4l.7 1.7c.1.3.1.5-.1.7l-.5.6c-.2.2-.2.4 0 .7.5.8 1.2 1.5 2.1 2 .3.2.5.2.7-.1l.7-.8c.2-.2.4-.3.7-.2l1.6.8c.3.1.4.3.4.5 0 .3-.2 1.2-.8 1.6-.5.4-1.1.6-1.8.4-.7-.2-1.6-.5-2.7-1.2-1.4-.9-2.3-2-2.9-2.8-.6-.8-1-1.7-1-2.5 0-.8.4-1.3.7-1.7Z" /></>,
  };

  return <svg {...common}>{paths[name] || paths.arrow}</svg>;
};

const services = [
  {
    number: '01',
    icon: 'truck',
    title: 'Transporte local',
    description: 'Movemos mercancía y carga dentro de tu ciudad con entregas coordinadas y atención directa.',
    detail: 'Recolección y entrega',
  },
  {
    number: '02',
    icon: 'box',
    title: 'Carga dedicada',
    description: 'Unidades asignadas a tu envío para transportar productos, equipos o materiales con cuidado.',
    detail: 'Servicio a tu medida',
  },
  {
    number: '03',
    icon: 'location',
    title: 'Transporte foráneo',
    description: 'Trasladamos tu carga entre ciudades con coordinación de ruta y comunicación durante el servicio.',
    detail: 'Rutas nacionales',
  },
];

const steps = [
  ['01', 'Cuéntanos qué necesitas', 'Comparte origen, destino y tipo de carga.'],
  ['02', 'Recibe tu cotización', 'Te damos un precio claro, sin cargos sorpresa.'],
  ['03', 'Nosotros nos encargamos', 'Llegamos a tiempo y seguimos tu envío hasta la entrega.'],
];

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [sent, setSent] = useState(false);
  const [whatsAppUrl, setWhatsAppUrl] = useState('');
  const [form, setForm] = useState({
    name: '',
    phone: '',
    origin: '',
    destination: '',
    service: 'Transporte local',
    date: '',
  });

  const localDate = new Date();
  const today = `${localDate.getFullYear()}-${String(localDate.getMonth() + 1).padStart(2, '0')}-${String(localDate.getDate()).padStart(2, '0')}`;

  const updateForm = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
    setSent(false);
    setWhatsAppUrl('');
  };

  const submitQuote = (event) => {
    event.preventDefault();
    const message = [
      'Hola, quiero cotizar un servicio con Flete Move.',
      `Nombre: ${form.name}`,
      `Teléfono: ${form.phone}`,
      `Servicio: ${form.service}`,
      `Origen: ${form.origin}`,
      `Destino: ${form.destination}`,
      `Fecha aproximada: ${form.date}`,
    ].join('\n');
    setWhatsAppUrl(`${WHATSAPP_LINK}?text=${encodeURIComponent(message)}`);
    setSent(true);
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="site-shell">
      <div className="topbar">
        <div className="container topbar-inner">
          <span><Icon name="clock" size={15} /> Lun–Sáb, 8:00 a 20:00</span>
          <a href={WHATSAPP_LINK} target="_blank" rel="noreferrer"><Icon name="whatsapp" size={15} /> Cotiza por WhatsApp <strong>55 7884 6045</strong></a>
        </div>
      </div>

      <header className="site-header">
        <div className="container nav-wrap">
          <a className="brand" href="#inicio" onClick={closeMenu} aria-label="Flete Move, logística y transporte">
            <img className="brand-logo" src="/fletemove-logo.png" alt="Flete Move, logística y transporte" />
          </a>

          <button
            className="menu-toggle"
            type="button"
            aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <Icon name={menuOpen ? 'close' : 'menu'} size={24} />
          </button>

          <nav className={`main-nav${menuOpen ? ' is-open' : ''}`} aria-label="Navegación principal">
            <a href="#servicios" onClick={closeMenu}>Servicios</a>
            <a href="#nosotros" onClick={closeMenu}>Nosotros</a>
            <a href="#proceso" onClick={closeMenu}>Cómo funciona</a>
            <a href="#opiniones" onClick={closeMenu}>Opiniones</a>
            <a className="nav-cta" href={WHATSAPP_LINK} target="_blank" rel="noreferrer" onClick={closeMenu}>Cotiza por WhatsApp <Icon name="whatsapp" size={16} /></a>
          </nav>
        </div>
      </header>

      <main>
        <section className="hero" id="inicio">
          <div className="hero-photo" aria-hidden="true" />
          <div className="container hero-content">
            <div className="hero-copy">
              <div className="eyebrow"><span className="eyebrow-dot" /> TRANSPORTE DE CARGA</div>
              <h1>Movemos tu carga.<br />Impulsamos <em>tu negocio.</em></h1>
              <p className="hero-lede">Soluciones de transporte local y foráneo para tu mercancía. Coordinamos cada envío con atención, cuidado y comunicación clara.</p>
              <div className="hero-actions">
                <a className="button button-primary" href={WHATSAPP_LINK} target="_blank" rel="noreferrer">Cotiza por WhatsApp <Icon name="whatsapp" size={18} /></a>
                <a className="text-link" href="#servicios">Conoce nuestros servicios <span>↓</span></a>
              </div>
              <div className="hero-proof">
                <div className="hero-proof-icon"><Icon name="truck" size={17} /></div>
                <div><div className="stars"><b>TRANSPORTE DE CARGA</b></div><small>Servicios locales y foráneos</small></div>
              </div>
            </div>

            <div className="hero-card">
              <div className="hero-card-icon"><Icon name="truck" size={21} /></div>
              <div><strong>Transporte coordinado</strong><span>Atención durante cada servicio</span></div>
              <Icon name="check" size={19} />
            </div>
            <div className="hero-caption"><span /> LISTOS PARA MOVERTE</div>
          </div>
          <div className="hero-bottom container">
            <span>TRANSPORTE PENSADO PARA TI</span>
            <span className="hero-bottom-line" />
            <span>CDMX · EDOMEX · TODA LA REPÚBLICA</span>
          </div>
        </section>

        <section className="trust-strip" aria-label="Beneficios">
          <div className="container trust-grid">
            <div><Icon name="clock" /><span><strong>Envíos coordinados</strong><small>Planeamos cada servicio</small></span></div>
            <div><Icon name="shield" /><span><strong>Manejo cuidadoso</strong><small>Atención a tu mercancía</small></span></div>
            <div><Icon name="location" /><span><strong>Rutas locales y foráneas</strong><small>Transporte entre ciudades</small></span></div>
            <div><Icon name="check" /><span><strong>Atención directa</strong><small>Comunicación clara</small></span></div>
          </div>
        </section>

        <section className="section services-section" id="servicios">
          <div className="container">
            <div className="section-heading">
              <div>
                <div className="eyebrow eyebrow-dark">SOLUCIONES A TU MEDIDA</div>
                <h2>Transporte para<br />cada <em>destino.</em></h2>
              </div>
              <p>Movemos mercancía, productos y equipos para que lleguen a donde los necesitas. Cuéntanos qué quieres transportar y coordinamos el servicio contigo.</p>
            </div>
            <div className="service-grid">
              {services.map((service) => (
                <article className="service-card" key={service.title}>
                  <div className="service-card-top"><span>{service.number}</span><div className="service-icon"><Icon name={service.icon} size={24} /></div></div>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <div className="service-card-bottom"><span>{service.detail}</span><a href="#cotizar" aria-label={`Cotizar ${service.title}`}><Icon name="arrow" size={18} /></a></div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="about-section" id="nosotros">
          <div className="container about-grid">
            <div className="about-visual">
              <div className="about-image" role="img" aria-label="Equipo Flete Move listo para transportar tu carga" />
              <div className="experience-card"><strong>FM</strong><span>TRANSPORTE<br />DE CARGA</span></div>
              <div className="image-stamp">CARGA<br /><b>MOVE</b></div>
            </div>
            <div className="about-copy">
              <div className="eyebrow eyebrow-dark">TU ALIADO EN TRANSPORTE</div>
              <h2>Tu carga en<br /><em>movimiento.</em></h2>
              <p className="about-lede">En Flete Move conectamos negocios con sus destinos. Coordinamos el traslado de mercancía con comunicación directa y cuidado durante cada servicio.</p>
              <div className="about-points">
                <div><span className="point-check"><Icon name="check" size={16} /></span><span>                <strong>Atención personal</strong><small>Coordinamos contigo los detalles de cada traslado.</small></span></div>
                <div><span className="point-check"><Icon name="check" size={16} /></span><span>                <strong>Rutas coordinadas</strong><small>Planeamos el trayecto según tu origen y destino.</small></span></div>
                <div><span className="point-check"><Icon name="check" size={16} /></span><span>                <strong>Cuidado de tu mercancía</strong><small>Atención responsable durante el traslado.</small></span></div>
              </div>
              <a href="#proceso" className="text-link dark-link">Así trabajamos <Icon name="arrow" size={17} /></a>
            </div>
          </div>
        </section>

        <section className="process-section section" id="proceso">
          <div className="container">
            <div className="process-heading">
              <div className="eyebrow">ASÍ DE FÁCIL</div>
              <h2>De aquí para allá,<br /><em>sin vueltas.</em></h2>
              <p>En tres pasos, tu carga ya está en camino.</p>
            </div>
            <div className="steps-grid">
              {steps.map(([number, title, description], index) => (
                <article className="step" key={number}>
                  <div className="step-top"><span>{number}</span>{index < steps.length - 1 && <i />}</div>
                  <h3>{title}</h3>
                  <p>{description}</p>
                </article>
              ))}
            </div>
            <a className="button button-light" href="#cotizar">Empezar mi cotización <Icon name="arrow" size={18} /></a>
          </div>
        </section>

        <section className="quote-section section" id="cotizar">
          <div className="container quote-grid">
            <div className="quote-intro">
              <div className="eyebrow eyebrow-dark">EMPECEMOS</div>
              <h2>Tu próximo<br />movimiento<br /><em>empieza aquí.</em></h2>
              <p>Cuéntanos un poco y nuestro equipo te contactará con una cotización clara y sin compromiso.</p>
              <div className="quote-contact">
                <span className="quote-phone-icon"><Icon name="whatsapp" size={20} /></span>
                <span><small>Escríbenos directamente por WhatsApp</small><a href={WHATSAPP_LINK} target="_blank" rel="noreferrer">55 7884 6045</a></span>
              </div>
              <div className="quote-note"><Icon name="shield" size={18} /> Tus datos están seguros y solo los usamos para tu cotización.</div>
            </div>
            <div className="quote-card">
              <div className="quote-card-heading"><span>01 <i /> COTIZACIÓN GRATUITA</span><h3>Cotiza el transporte de tu carga</h3><p>Los campos con * son obligatorios.</p></div>
              {sent ? (
                <div className="success-message" role="status">
                  <span className="success-icon"><Icon name="check" size={28} /></span>
                  <h3>¡Gracias, {form.name.split(' ')[0]}!</h3>
                  <p>Tu solicitud de {form.service.toLowerCase()} desde {form.origin} hasta {form.destination} está lista. Envíala por WhatsApp y un asesor te contactará al <strong>{form.phone}</strong> para compartir tu cotización.</p>
                  <a className="button button-primary success-submit" href={whatsAppUrl} target="_blank" rel="noreferrer">Enviar solicitud por WhatsApp <Icon name="arrow" size={17} /></a>
                  <button type="button" className="text-link dark-link" onClick={() => setSent(false)}>Editar solicitud <Icon name="arrow" size={16} /></button>
                </div>
              ) : (
                <form className="quote-form" onSubmit={submitQuote}>
                  <div className="form-row">
                    <label>Nombre completo *<input name="name" value={form.name} onChange={updateForm} placeholder="¿Cómo te llamas?" autoComplete="name" required /></label>
                    <label>Teléfono *<input name="phone" value={form.phone} onChange={updateForm} placeholder="55 1234 5678" type="tel" autoComplete="tel" required /></label>
                  </div>
                  <div className="form-row">
                    <label>Ciudad de origen *<span className="input-icon"><Icon name="location" size={16} /><input name="origin" value={form.origin} onChange={updateForm} placeholder="¿Desde dónde?" required /></span></label>
                    <label>Ciudad de destino *<span className="input-icon"><Icon name="location" size={16} /><input name="destination" value={form.destination} onChange={updateForm} placeholder="¿Hacia dónde?" required /></span></label>
                  </div>
                  <div className="form-row">
                    <label>¿Qué servicio necesitas? *<select name="service" value={form.service} onChange={updateForm}><option>Transporte local</option><option>Carga dedicada</option><option>Transporte foráneo</option><option>Transporte de mercancía</option></select></label>
                    <label>Fecha aproximada *<input name="date" type="date" min={today} value={form.date} onChange={updateForm} required /></label>
                  </div>
                  <button className="button button-primary form-submit" type="submit">Solicitar cotización gratis <Icon name="arrow" size={18} /></button>
                  <small className="form-footnote"><Icon name="clock" size={14} /> Te contactamos en menos de 30 minutos en horario laboral.</small>
                </form>
              )}
            </div>
          </div>
        </section>

        <section className="reviews-section section" id="opiniones">
          <div className="container">
            <div className="reviews-heading">
              <div><div className="eyebrow eyebrow-dark">PALABRA DE CLIENTES</div><h2>Se nota cuando<br />alguien <em>se preocupa.</em></h2></div>
              <p className="coverage-note">Servicio local y foráneo<br /><strong>Cotización según tu ruta y carga</strong></p>
            </div>
            <div className="review-grid">
              <article className="review-card"><Icon name="box" size={24} /><div className="review-kicker">01 · TU CARGA</div><h3>Cuéntanos qué necesitas mover</h3><p>Comparte el tipo de mercancía, el origen y el destino para revisar tu servicio.</p></article>
              <article className="review-card"><Icon name="location" size={24} /><div className="review-kicker">02 · TU RUTA</div><h3>Coordinamos el traslado</h3><p>Revisamos los detalles de tu recorrido y coordinamos contigo la logística.</p></article>
              <article className="review-card"><Icon name="truck" size={24} /><div className="review-kicker">03 · TU COTIZACIÓN</div><h3>Recibe una propuesta clara</h3><p>Te contactamos para conversar sobre la carga, la ruta y el servicio requerido.</p></article>
            </div>
          </div>
        </section>

        <section className="bottom-cta">
          <div className="container bottom-cta-inner"><div><span>¿LISTO PARA MOVERTE?</span><h2>Hagámoslo fácil.</h2></div><a className="button button-light" href={WHATSAPP_LINK} target="_blank" rel="noreferrer">Cotiza por WhatsApp <Icon name="whatsapp" size={18} /></a></div>
        </section>
      </main>

      <footer className="site-footer">
        <div className="container footer-main">
          <div className="footer-brand">
            <a className="brand footer-logo" href="#inicio" aria-label="Flete Move, inicio">
              <img className="brand-logo" src="/fletemove-logo.png" alt="Flete Move, logística y transporte" />
            </a>
            <p>Movemos lo que más te importa, con cuidado, puntualidad y una sonrisa.</p>
          </div>
          <div className="footer-column"><strong>Explora</strong><a href="#servicios">Servicios</a><a href="#nosotros">Nosotros</a><a href="#proceso">Cómo funciona</a><a href="#opiniones">Opiniones</a></div>
          <div className="footer-column"><strong>Servicios</strong><a href="#cotizar">Transporte local</a><a href="#cotizar">Carga dedicada</a><a href="#cotizar">Transporte foráneo</a><a href="#cotizar">Transporte de mercancía</a></div>
          <div className="footer-column footer-contact"><strong>Hablemos</strong><a href="tel:+525578846045"><Icon name="phone" size={16} /> 55 7884 6045</a><a href="https://www.instagram.com/FleteMove/" target="_blank" rel="noreferrer"><Icon name="instagram" size={16} /> Instagram · FleteMove</a><a href="https://www.facebook.com/FleteMove/" target="_blank" rel="noreferrer"><Icon name="facebook" size={16} /> Facebook · FleteMove</a><span>Lun–Sáb · 8:00 a 20:00</span></div>
        </div>
        <div className="container footer-bottom"><span>© 2026 Flete Move. Todos los derechos reservados.</span><span>Hecho para moverte mejor <span className="footer-heart">♥</span></span></div>
      </footer>
      <a className="whatsapp-float" href={WHATSAPP_LINK} target="_blank" rel="noreferrer" aria-label="Abrir chat de Flete Move por WhatsApp">
        <Icon name="whatsapp" size={23} />
        <span>Cotiza por WhatsApp</span>
      </a>
    </div>
  );
}

export default App;
